module.exports = __webpack_public_path__ + "static/eindruecke8-65991257fa576f1bcff03a43332e3d62.jpg";